// custom pages
import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const DashboardAPI = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getVRAScheduleAPI() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      let res = await fetch(`${config.host}/panel/dashboard/vra-schedule`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getVRAScheduleAPI
  };
};

export default DashboardAPI;
